import clsx from 'clsx';
import * as React from 'react';
import { observer } from 'mobx-react';
import { NavLink } from 'react-router-dom';
import { T } from '../../../Translations';
import { peopleUrl } from '../../../ClientRoutes';

const Breadcrumb: React.FC = () => {
  return (
    <div className={clsx('mb-7 flex')}>
      <NavLink
        to={peopleUrl}
        className={clsx(
          'text-sm text-teal-800 hover:underline hover:decoration-teal-800',
          'hover:decoration-2 hover:underline-offset-4',
        )}
      >
        <T kind="People" />
      </NavLink>
    </div>
  );
};

export default observer(Breadcrumb);
